<template>
  <Field
    class="picker-class"
    v-model="dateValue"
    readonly
    :placeholder="$t('ep_admin_tips_select')"
    :disabled="disabled"
    right-icon="calendar-o"
    @click="handleShow"
  />
  <Calendar
    v-model:show="showCalendar"
    color="rgb(255, 83, 83)"
    @confirm="onConfirm"
    confirm-text="Confirm"
    :min-date="minDate"
    :max-date="maxDate"
  />
</template>
<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { Calendar, Field } from 'vant'
import dayjs from 'dayjs'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  value: {
    required: true,
    type: String,
    default: ''
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['change'])
const dateValue = ref(props.value)
const showCalendar = ref(false)
const minDate = new Date(2000, 0, 1)
const maxDate = new Date(2050, 0, 31)

const format = computed(() => {
  if (props.data.dateType === '2') return 'YYYY.MM.DD'
  if (props.data.dateType === '3') return 'DD/MMM/YYYY'
  return 'MMM DD,YYYY'
})

const handleShow = () => {
  if (props.disabled) return
  showCalendar.value = true
}

const onConfirm = value => {
  showCalendar.value = false
  dateValue.value = value ? dayjs(value).format(format.value) : undefined
  emit('change', value ? dayjs(value).valueOf() : undefined)
}

onMounted(async () => {
  if (props.data.fieldValue) {
    dateValue.value = dayjs(Number(props.data.fieldValue)).format(format.value)
  }
})
</script>
